import { render, staticRenderFns } from "./SolanRubricsPure.vue?vue&type=template&id=0bea1f78&scoped=true&"
import script from "./SolanRubricsPure.vue?vue&type=script&lang=ts&"
export * from "./SolanRubricsPure.vue?vue&type=script&lang=ts&"
import style0 from "./SolanRubricsPure.vue?vue&type=style&index=0&id=0bea1f78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea1f78",
  null
  
)

export default component.exports